import { Link } from "react-router-dom";
import { Logo } from "../Logo";
import { Facebook, Instagram, Linkedin, Twitter, Mail, Phone } from "lucide-react";
import { CONTACT, fmtPhone, tel } from "../../lib/contact";

const COLS = [
  { title: "Explore", links: [["Buy", "/buy"], ["Rent", "/rent"], ["Plots & Land", "/plots"], ["Commercial", "/commercial"], ["New Projects", "/projects"]] },
  { title: "Top Cities", links: [["Noida", "/city/noida"], ["Greater Noida", "/city/greater-noida"], ["Noida Extension", "/city/noida-extension"], ["Yamuna Expressway", "/city/yamuna-expressway"], ["Ghaziabad", "/city/ghaziabad"]] },
  { title: "Company", links: [["Invest", "/invest"], ["Developers", "/developers"], ["Insights", "/insights"], ["Calculators", "/calculators"], ["Post Property", "/post-property"], ["Contact Us", "/contact"], ["Careers", "/careers"], ["Privacy Policy", "/privacy"]] },
];

export function Footer() {
  return (
    <footer className="bg-pbs-plum text-white/80 mt-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <Logo light tagline />
            <p className="mt-4 text-sm leading-relaxed max-w-xs text-white/70">
              A modern real-estate discovery platform connecting buyers, investors and developers with curated, verified opportunities across India.
            </p>
            <div className="flex gap-3 mt-5">
              {[Facebook, Instagram, Linkedin, Twitter].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-lg bg-white/10 hover:bg-pbs-orange flex items-center justify-center transition-colors">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="text-white font-bold text-sm mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={label}><Link to={to} className="text-sm text-white/70 hover:text-pbs-gold transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/60">© 2026 Shivora Square India Private Limited. PlotBySquare is a brand of Shivora Square India Private Limited. All property data shown is illustrative sample content.</p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-white/70" data-testid="footer-contact">
            <a href={tel(CONTACT.phone)} className="flex items-center gap-1.5 hover:text-white"><Phone size={13} /> {fmtPhone(CONTACT.phone)}</a>
            <a href={tel(CONTACT.phoneAlt)} className="flex items-center gap-1.5 hover:text-white"><Phone size={13} /> {fmtPhone(CONTACT.phoneAlt)}</a>
            <a href={`mailto:${CONTACT.info}`} className="flex items-center gap-1.5 hover:text-white"><Mail size={13} /> {CONTACT.info}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
